import React from "react";

const Ad = () => {
  const adCode = (
    <script
      async
      src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-9081019223186749"
    ></script>
  );

  return <div dangerouslySetInnerHTML={{ __html: adCode }} />;
};

export default Ad;
